import { computed, ref } from "vue";
import { gt } from "semver";

const widgetVersion = ref<string>();

const setWidgetVersion = (version: string) => {
  widgetVersion.value = version;
};

const isVersionNewer = (version: string) => {
  if (!widgetVersion.value) {
    return false;
  }

  return gt(version, widgetVersion.value);
};

const getLatestWidgetVersion = async () => {
  if (!process.env.VUE_APP_VERSION_URL) {
    console.warn("VUE_APP_VERSION_URL missing from config");
    return null;
  }

  try {
    const res = await fetch(
      process.env.VUE_APP_VERSION_URL +
        "?_=" +
        Math.round(new Date().getTime() / 1000)
    );
    const { version } = await res.json();
    return version.version;
  } catch (err) {
    console.warn("Error getting latest widget version info", err);
    return null;
  }
};

export function useWidgetVersion() {
  return {
    getLatestWidgetVersion,
    setWidgetVersion,
    isVersionNewer,

    widgetVersion: computed(() => widgetVersion.value),
  };
}
